import { PCPCommonModule } from './../../pcpcommon.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyUserProfileComponent } from './myuserprofile.component';
// import { TabViewModule } from 'primeng/tabview'; // Commented out due to PrimeNG v20 provider issues
import { MyUserInformationModule } from './tabs/myuserinformation/myuserinformation.module';
import { MyUserSettingsModule } from './tabs/myusersettings/myusersettings.module';
import { MyUserNotificationsModule } from './tabs/myusernotifications/myusernotifications.module';
import { CheckAccessDirective } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        MyUserInformationModule,
        MyUserSettingsModule,
        MyUserNotificationsModule,
        PCPCommonModule,
        // TabViewModule,
        MyUserProfileComponent,
        CheckAccessDirective
    ],
    exports: [MyUserProfileComponent]
})
export class MyUserProfileModule { }
